<script>
import EntrepotDocsListDesktopView from "./EntrepotDocsListDesktopView.vue";

/**
 * Desktop list layout bridge.
 * Renders EntrepotDocsListDesktopView using the parent list instance as
 * context so template bindings and $refs stay on list.vue (provide/inject).
 */
export default {
  name: "EntrepotDocsListDesktopBridge",
  inject: ["entrepotDocsList"],
  render() {
    const list = this.entrepotDocsList;
    const viewOptions =
      EntrepotDocsListDesktopView.options || EntrepotDocsListDesktopView;
    const render = viewOptions.render;

    if (!list || typeof render !== "function") {
      return null;
    }

    const options = list.$options;
    const prevStaticRenderFns = options.staticRenderFns;
    const prevScopeId = options._scopeId;

    // Keep shell `_scopeId` so scoped CSS on list.vue applies to the
    // bridged desktop template (same pattern as invoice list).
    options.staticRenderFns = viewOptions.staticRenderFns;

    try {
      return render.call(list, list.$createElement);
    } finally {
      options.staticRenderFns = prevStaticRenderFns;
      options._scopeId = prevScopeId;
    }
  },
};
</script>
